<template>
  <div class="tacticsBox">
    <el-row style="background: #ffffff;" class="shadow">
      <h3 class="tactics">因子分布</h3>
      <el-col :span="24" style="padding: 35px;">
        <ul class="titList">
          <li>
            <span class="li" style="background:#FD7D84;"></span>
            显著正相关
          </li>
          <li>
            <span class="li" style="background:#fadb14;"></span>
            不显著
          </li>
          <li>
            <span class="li" style="background:#1386FF;"></span>
            显著负相关
          </li>
        </ul>
        <!-- <el-col :span="24">
          <p style="margin-bottom: 10px; margin-top: -10px;">
            <Tag color="#FD7D84">显著正相关</Tag>
            <Tag color="#fadb14">不显著</Tag>
            <Tag color="#1386FF">显著负相关</Tag>
          </p>
        </el-col>-->
        <el-col :span="12">
          <vue-echarts
            ref="styleRelation-1"
            width="100%"
            height="340px"
            :renderOnMounted="false"
            :options="{}"
          ></vue-echarts>
        </el-col>
        <el-col :span="12">
          <vue-echarts
            ref="styleRelation-2"
            width="100%"
            height="340px"
            :renderOnMounted="false"
            :options="{}"
          ></vue-echarts>
        </el-col>
        <el-col :span="12">
          <vue-echarts
            ref="styleRelation-3"
            width="100%"
            height="340px"
            :renderOnMounted="false"
            :options="{}"
          ></vue-echarts>
        </el-col>
        <el-col :span="12">
          <vue-echarts
            ref="styleRelation-4"
            width="100%"
            height="340px"
            :renderOnMounted="false"
            :options="{}"
          ></vue-echarts>
        </el-col>
        <!-- 5--10 -->
        <el-col :span="12">
          <vue-echarts
            ref="styleRelation-5"
            width="100%"
            height="340px"
            :renderOnMounted="false"
            :options="{}"
          ></vue-echarts>
        </el-col>
        <el-col :span="12">
          <vue-echarts
            ref="styleRelation-6"
            width="100%"
            height="340px"
            :renderOnMounted="false"
            :options="{}"
          ></vue-echarts>
        </el-col>
        <el-col :span="12">
          <vue-echarts
            ref="styleRelation-7"
            width="100%"
            height="340px"
            :renderOnMounted="false"
            :options="{}"
          ></vue-echarts>
        </el-col>
        <el-col :span="12">
          <vue-echarts
            ref="styleRelation-8"
            width="100%"
            height="340px"
            :renderOnMounted="false"
            :options="{}"
          ></vue-echarts>
        </el-col>
        <el-col :span="12">
          <vue-echarts
            ref="styleRelation-9"
            width="100%"
            height="340px"
            :renderOnMounted="false"
            :options="{}"
          ></vue-echarts>
        </el-col>
        <el-col :span="12">
          <vue-echarts
            ref="styleRelation-10"
            width="100%"
            height="340px"
            :renderOnMounted="false"
            :options="{}"
          ></vue-echarts>
        </el-col>
        <!-- <div style="min-width:1400px;margin-left:69px;padding-top: 20px;">
        </div>-->
      </el-col>
    </el-row>
  </div>
</template>
<script>
// common/kecharts
import tracharts from "./common/tracharts";
import sameEcharts from "./common/sameEcharts";
import echartsTime from "./common/echartsTime";

import vueEcharts from "./common/vueEcharts";
const commonOptions = {
  // title: '',
  backgroundColor: "#fff",
  color: ["#F15A5A", "#9FCFFF", "#FFD96C"],
  // legend: {
  //   data: [],
  //   textStyle: {
  //     color: '#999'
  //   }
  // },
  tooltip: {
    trigger: "axis",
  },
  dataZoom: {
    type: "inside", // 滚动放大缩小
  },
  xAxis: {
    type: "category",
    splitLine: {
      lineStyle: {
        color: "#eee",
      },
    },
    data: [],
  },
  yAxis: {
    type: "value",
    // scale: true,
    splitLine: {
      lineStyle: {
        color: "#eee",
      },
    },
  },
  series: [],
};
// import kecharts from "../../strategy/common/kecharts";
export default {
  components: { tracharts, sameEcharts, echartsTime, vueEcharts },
  props: {
    getData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      echartsType1: false,
      echartsType2: false,
      data: {},
      distribute: {
        dataValue: [],
        tiem: [],
      },
      // 因子行业
      industry: {
        dataValue: [],
        tiem: [],
      },
      sCombinPerm: {},
      sFactorPerm: {},
      sParam: {},
      sFactor: {}, // 因子收益
      sameData: {
        dataValue: [],
        tiem: [],
      }, // 换手率分析
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.data = this.getData;
      this.drawStyleRelation();
    },
    // 绘制风格因子相关性
    drawStyleRelation() {
      const colors = ["#FD7D84", "#ffdc3d", "#1386FF"];
      for (let i = 1; i <= 10; i++) {
        const index = i;
        const data = this.data.listStleCorrelation[index - 1];
        const config = JSON.parse(JSON.stringify(commonOptions));
        config.title = {
          text: data.wstrStyle,
          textStyle: {
            fontSize: 13,
          },
        };
        config.xAxis.data = data.listValues.map((item) => item.dtDay);
        config.series.push({
          type: "bar",
          name: data.wstrStyle,
          data: data.listValues.map((item) => {
            let [color] = colors;
            const dbCorrelation = Number(item.dbCorrelation).toFixed(4);
            //  this.util.number.toFixed(item.dbCorrelation, 4);
            if (item.dbSignificant > 0.05) {
              // 不显著
              color = colors[1];
            } else if (item.dbSignificant <= 0.05 && dbCorrelation >= 0) {
              // 显著正相关
              color = colors[0];
            } else if (item.dbSignificant < 0.05 && dbCorrelation < 0) {
              // 显著负相关
              color = colors[2];
            }
            return {
              value: dbCorrelation,
              itemStyle: {
                color,
              },
            };
          }),
        });
        config.series.push({
          type: "line",
          name: `${data.wstrStyle}-曲线`,
          data: data.listValues.map((item) =>
            Number(item.dbCorrelation).toFixed(4)
          ),
          lineStyle: {
            width: 1,
            color: "#999",
          },
        });
        if (i <= 5) {
          setTimeout(() => {
            this.$refs[`styleRelation-${index}`].render(config);
          }, 100);
        } else {
          this.$refs[`styleRelation-${index}`].render(config);
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.tacticsBox {
  .tactics {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
    height: 42px;
    line-height: 42px;
    background: rgba(240, 242, 245, 1);
    box-shadow: 0px 0px 8px 0px rgba(239, 242, 255, 1);
    text-shadow: 0px 0px 4px rgba(214, 234, 255, 1);
    padding-left: 10px;
  }
  .UlTOP {
    margin: 34px 0px 33px 48px;
    li:first-child {
      height: 110px;
    }
    li {
      color: #666666;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      border-bottom: 1px solid #dddddd;
      height: 32px;
      line-height: 32px;
      h4 {
        color: #666666;
        font-size: 12px;
        font-weight: bold;
      }
      h3 {
        font-size: 35px;
        font-weight: 400;
        line-height: 50px;
      }
    }
    .ulRed {
      color: #ff5454;
    }
    .ulBule {
      color: #1482f1;
    }
  }
  .pgUp {
    color: #f15a5a;
  }
  .pgDn {
    color: #1bb10a;
  }
  .tacticsUl {
    margin: 0 14px;
    li {
      color: #666666;
      display: inline-block;
      width: 20%;
      text-align: center;
      p:nth-child(1) {
        margin: 18px 0;
        font-size: 16px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
      }
      p:nth-child(2) {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        line-height: 12px;
      }
    }
  }
  .shadow {
    box-shadow: 0px 0px 4px 0px rgba(214, 234, 255, 1);
  }
  .titList {
    clear: both;
    overflow: hidden;
    width: 310px;
    margin: 0 auto;
    margin-bottom: 23px;
    text-align: center;
    li {
      float: left;
      margin-right: 20px;
    }
    .li {
      display: inline-block;
      width: 20px;
      height: 6px;
      margin-right: 4px;
    }
  }
}
</style>
